import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { formatDate } from '@/app/helpers/date.helpers.ts';

export interface FilterStateProps<T> {
  data: T[];
  filterPredicate?: (data: T, filter: string) => boolean;
}

function defaultFilter<T>(value: T, filter: string): boolean {
  if (filter === undefined || filter === null || filter === '') {
    return true;
  }

  let result = false;
  for (const key in value) {
    if (
      value[key] === undefined ||
      value[key] === null ||
      value[key] === '' ||
      key === 'id' ||
      key.includes('Id') ||
      key === 'key' ||
      key.includes('Key')
    ) {
      continue;
    }

    if (typeof value[key] === 'object' && defaultFilter(value[key], filter)) {
      result = true;
    }

    let propValue = typeof value[key] !== 'string' ? value[key].toString() : value[key];

    if (DateTime.fromISO(propValue).isValid) {
      propValue = formatDate(propValue, DateTime.DATETIME_SHORT);
    }

    if (propValue.toLowerCase().includes(filter.toLowerCase())) {
      result = true;
    }
  }

  return result;
}

export function useFilter<T>({ data, filterPredicate = defaultFilter }: FilterStateProps<T>) {
  const [filter, setFilter] = useState<string>('');
  const [filteredData, setFilteredData] = useState<T[]>(data ?? []);

  useEffect(() => {
    if (data?.length) {
      const filtered =
        filter?.length > 0 ? [...data].filter(item => filterPredicate(item, filter)) : [...data];
      setFilteredData(filtered);
    }
  }, [filter, data]);

  return {
    filteredData,
    filter,
    setFilter,
  };
}
